// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elements-library {
    width: 100%;
    background: transparent;
    padding: 0;
}

.elements-library h3 {
    margin: 0;
    font-size: 0.8em;
    text-transform: uppercase;
    color: #718096;
    letter-spacing: 0.05em;
    font-weight: 700;
}

.library-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.library-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px 4px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    cursor: grab;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    position: relative;
}

.library-item:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    border-color: #4299e1;
    background: #f0f9ff;
}

.library-item:active {
    cursor: grabbing;
}

.library-icon {
    font-size: 1.25em;
    line-height: 1;
}

.library-name {
    font-size: 0.7em;
    color: #4a5568;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}

.btn-delete-asset {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #fc8181;
    color: white;
    border: none;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.library-item:hover .btn-delete-asset {
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/MaqueteEditor/ElementsLibrary.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iDAAiD;IACjD,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd","sourcesContent":[".elements-library {\r\n    width: 100%;\r\n    background: transparent;\r\n    padding: 0;\r\n}\r\n\r\n.elements-library h3 {\r\n    margin: 0;\r\n    font-size: 0.8em;\r\n    text-transform: uppercase;\r\n    color: #718096;\r\n    letter-spacing: 0.05em;\r\n    font-weight: 700;\r\n}\r\n\r\n.library-items {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 8px;\r\n}\r\n\r\n.library-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 4px;\r\n    padding: 8px 4px;\r\n    background: white;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    cursor: grab;\r\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n    position: relative;\r\n}\r\n\r\n.library-item:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\r\n    border-color: #4299e1;\r\n    background: #f0f9ff;\r\n}\r\n\r\n.library-item:active {\r\n    cursor: grabbing;\r\n}\r\n\r\n.library-icon {\r\n    font-size: 1.25em;\r\n    line-height: 1;\r\n}\r\n\r\n.library-name {\r\n    font-size: 0.7em;\r\n    color: #4a5568;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 100%;\r\n}\r\n\r\n.btn-delete-asset {\r\n    position: absolute;\r\n    top: -5px;\r\n    right: -5px;\r\n    background: #fc8181;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 18px;\r\n    height: 18px;\r\n    font-size: 10px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    opacity: 0;\r\n    transition: opacity 0.2s;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.library-item:hover .btn-delete-asset {\r\n    opacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
